import React from "react";

const CancelButton = ({disabled, onClick, children}) =>
{
    const clickHandler = disabled === false ? onClick : null;

    return (
        <button onClick={clickHandler} style={{marginLeft: '10px'}} disabled={disabled} type='button'
                className='btn btn-icon btn-secondary btn-icon-right btn-small'>{children}<i className="et-arrow-bold-left"/>
        </button>
    )
}

export { CancelButton } ;

